import jwtDecode from 'jwt-decode';

import { recursiveFreeze } from '@philips-emr/tws-utils';

const _type = Symbol('type');
const _jwtToken = Symbol('jwtToken');
const _payload = Symbol('payload');

export interface Claims {
  [key: string]: ClaimValue;
}

export interface JWTClaims extends Claims {
  sub: string;
  iss: string;
  exp: number;
  iat: number;
  aud: string;

  roles: string[];
  permissions: string[];
}

export type ClaimValue = boolean | number | string | readonly string[];

class JWTToken {

  [_type]: string;
  [_jwtToken]: string;
  [_payload]: JWTClaims;

  constructor(type: string, jwtToken: string) {
    const token = jwtDecode<JWTClaims>(jwtToken);

    this[_type] = type;
    this[_jwtToken] = jwtToken;
    this[_payload] = recursiveFreeze(token) as JWTClaims;
  }

  get subject(): string {
    return this.claims.sub;
  }

  get issuer(): string {
    return this.claims.iss;
  }

  get expiration(): number {
    return this.claims.exp;
  }

  get issuedAt(): number {
    return this.claims.iat;
  }

  get audience(): string {
    return this.claims.aud;
  }

  get claims(): JWTClaims {
    return this[_payload];
  }

  get roles(): string[] {
    return this.claims.roles;
  }

  get permissions(): string[] {
    return this.claims.permissions;
  }

  getType(): string {
    return this[_type];
  }

  rawToken(): string {
    return this[_jwtToken];
  }

}

export default JWTToken;
